import config from '../config';
import { fetchWithRetry } from '.';

export async function requestVerificationCode(idToken, email) {
  const url = `${config.coreApi.protocol}://${config.coreApi.host}/request-code`;
  const response = await fetchWithRetry(url, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${idToken}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ email })  
  });
  
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || `Failed to request code. Status: ${response.status}`);
  }
  return await response.json();
}

export async function verifyEmailCode(idToken, email, code) {
  const url = `${config.coreApi.protocol}://${config.coreApi.host}/verify-code`;
  const response = await fetchWithRetry(url, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${idToken}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ email, code })  
  });
  
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || `Verification failed. Status: ${response.status}`);
  }
  return await response.json();
}